import { FaGithub } from 'react-icons/fa';

const projects = [
    {
        name: 'tinyTransformerLLM',
        description:
            'A from-scratch implementation of a Transformer / LLM in Python — covers multi-head attention, positional encoding, and training from first principles.',
        url: 'https://github.com/raghul1998/tinyTransformerLLM',
        language: 'Python',
        langColor: '#3572A5',
    },
    {
        name: 'HushAI',
        description:
            'A full-stack email insight chatbot powered by GPT-3 Turbo — analyzes inbox correspondence and surfaces key patterns and summaries.',
        url: 'https://github.com/raghul1998/hushai_frontend',
        language: 'JavaScript',
        langColor: '#f1e05a',
    },
    {
        name: 'pdpstocks',
        description:
            'A stock portfolio management application in Java with support for portfolio creation, trade simulation, and performance tracking.',
        url: 'https://github.com/raghul1998/pdpstocks',
        language: 'Java',
        langColor: '#b07219',
    },
    {
        name: 'jobsearch-project',
        description:
            'Full-stack job search platform — Node.js/Express REST API backend paired with a web frontend for browsing and filtering job listings.',
        url: 'https://github.com/raghul1998/jobsearch-project-backend',
        language: 'JavaScript',
        langColor: '#f1e05a',
    },
    {
        name: 'tuiter',
        description:
            'A full-stack Twitter-inspired social platform built with React and Node.js, featuring posts, likes, and user profiles.',
        url: 'https://github.com/raghul1998/tuiter-react-web-app',
        language: 'JavaScript',
        langColor: '#f1e05a',
    },
    {
        name: 'chatbot',
        description:
            'A voice chatbot that integrates with ChatGPT, acting as a personalized assistant and conversational companion.',
        url: 'https://github.com/raghul1998/chatbot',
        language: 'Python',
        langColor: '#3572A5',
    },
];

export default function Projects() {
    return (
        <section id="projects" className="px-6 py-24 bg-[#161b22]" data-aos="fade-up">
            <div className="max-w-3xl mx-auto">
                <p className="text-[#f0883e] text-xs mb-2 font-mono tracking-widest uppercase">
                    {'// projects.json'}
                </p>
                <h2 className="text-2xl font-bold text-[#e6edf3] mb-10 font-mono">Projects</h2>

                <div className="grid gap-5 md:grid-cols-2">
                    {projects.map(({ name, description, url, language, langColor }) => (
                        <div
                            key={name}
                            className="bg-[#0d1117] border border-[#30363d] rounded-lg p-5 flex flex-col hover:border-[#3fb950]/50 transition-colors duration-300"
                        >
                            {/* Card header */}
                            <div className="flex items-center gap-2 mb-3 pb-3 border-b border-[#30363d]">
                                <FaGithub className="text-[#8b949e] text-sm flex-shrink-0" />
                                <span className="text-[#58a6ff] text-xs font-mono truncate">{name}</span>
                            </div>

                            {/* Description */}
                            <p className="text-[#8b949e] text-xs font-mono leading-6 flex-1 mb-4">
                                {description}
                            </p>

                            {/* Footer */}
                            <div className="flex items-center justify-between mt-auto pt-3 border-t border-[#30363d]">
                                <div className="flex items-center gap-1.5">
                                    <span
                                        className="w-2.5 h-2.5 rounded-full inline-block"
                                        style={{ backgroundColor: langColor }}
                                    />
                                    <span className="text-[#8b949e] text-xs font-mono">{language}</span>
                                </div>
                                <a
                                    href={url}
                                    target="_blank"
                                    rel="noopener noreferrer"
                                    className="text-[#3fb950] text-xs font-mono hover:underline underline-offset-4 transition-colors"
                                >
                                    view →
                                </a>
                            </div>
                        </div>
                    ))}
                </div>
            </div>
        </section>
    );
}
